import PropTypes from 'prop-types'

const LayoutInfo = (props) => {
  return (
    <>
      <div className="LayoutInfo">
        <div className="LayoutInfo-inner">
          <main className="LayoutInfo-main">
            {props.mainContent.props.children ? <div className="LayoutInfo-mainContent">{props.mainContent}</div> : ''}

            {props.footerContent.props.children ? (
              <div className="LayoutInfo-mainFooter">
                <div className="LayoutInfo-footerContent">{props.footerContent}</div>
              </div>
            ) : (
              ''
            )}
          </main>
        </div>
      </div>
    </>
  )
}

LayoutInfo.propTypes = {
  mainContent: PropTypes.any,
  footerContent: PropTypes.any
}

export default LayoutInfo
